<template>
  <!-- 地域分布地图 -->
  <div :ref="refId" :datas=datas style="width: 100%;height: 100%;"></div>
</template>

<script>

// refId                 图表id
// datas                 图表数据源

import chain from '../../../public/chain';
// 引入下载的地区json文件
export default {
  props: ['refId', 'datas', 'color', 'isExportFont', 'zoom'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
      // Max: {}
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(this.refId, newValue, this.color, this.isExportFont, this.zoom);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas.length > 0) {
      this.setPieOption(this.refId, this.datas, this.color, this.isExportFont, this.zoom);
    }
  },
  methods: {
    setPieOption(refId, datas, color, isExportFont, zoom) {
      const arrList = JSON.stringify(datas);
      if (JSON.parse(arrList).length > 0) {
        const max = Math.max.apply(Math, JSON.parse(arrList).map((item) => item.value));
        this.$echarts.registerMap('china', chain); // 注册地图
        this.pieEcharts = this.$echarts.init(this.$refs[refId]);
        this.pieOption = {

          tooltip: {
            trigger: 'item',
            confine: true, // 浮窗限制在图表内
            backgroundColor: 'rgba(64, 80, 118, 0.8)', // 通过设置rgba调节背景颜色与透明度
            borderColor: 'rgba(64, 80, 118, 0.8)',
            color: '#fff',
            textStyle: {
              color: '#fff',
            },
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985',
              },
            },
            formatter: (name) => {
              const item = JSON.parse(arrList).find((i) => i.name === name.name);
              var src = '';
              if (item) {
                var src = `${name.marker} ${name.data.name} &nbsp;&nbsp;${name.data.value}<br/>`;
                if (Array.isArray(item.value)) {
                  for (let i = 0; i < item.value.length; i++) {
                    src += `${name.marker} ${item.value[i].name} &nbsp;&nbsp;${item.value[i].value}<br/>`;
                  }
                }
              }
              return src;
            },
          },
          // geo: {
          //   zoom: 1.2
          // },

          // 左侧小导航 
          visualMap: {
            type: color ? 'piecewise' : null,
            show: true,
            min: 0,
            max: max / 2,
            text: ['高', '低'],
            realtime: true,
            calculable: true,
            textStyle: {
              color: '#fff',
            },
            inRange: {
              color: ['#00467F', '#A5CC82'],
            },
          },
          // var obj1 = ,
          // dataRange: {//左下角的颜色块。start：值域开始值；end：值域结束值；label：图例名称；color：自定义颜色值
          //   x: 'left',
          //   y: 'bottom',
          //   color: '#fff',
          //   splitList: [
          //     { start: 1000000000, label: '10亿以上', color: '#0b47a9' },
          //     { start: 700000000, end: 1000000000, label: '7亿-10亿', color: '#0d55cb' },
          //     { start: 500000000, end: 700000000, label: '5亿-7亿', color: '#1066f2' },
          //     { start: 100000000, end: 500000000, label: '1亿-5亿', color: '#5697ff' },
          //     { start: 59990000, end: 100000000, label: '5999万-1亿', color: '#17a9f9' },
          //     { start: 10000000, end: 59990000, label: '1000万-5999万', color: '#44b8f5' },
          //     { start: 5000000, end: 10000000, label: '500万-1000万', color: '#80d4ff' },
          //     { start: 1000000, end: 5000000, label: '100万-500万', color: '#99e6ff' },
          //     { start: 0, end: 1000000, label: '0-100万', color: '#b9f2fd' }
          //   ]
          // },
          series: [
            {
              name: '参建单位覆盖区域',
              roam: true,
              type: 'map',
              geoIndex: 0,
              map: 'china',
              zoom: zoom ? 1.2 : 1,
              layoutCenter: ['50%', '50%'],
              label: {
                normal: {
                  //静态的时候展示样式
                  show: true, //是否显示地图省份得名称
                  formatter: (params) => {
                    if (isNaN(params.value)) {
                      return `${params.name}`
                    } else {
                      if (params.value > 100000000) {
                        params.value = (params.value / 100000000).toFixed(2) + '亿'
                      } else if (params.value > 10000) {
                        params.value = (params.value / 10000).toFixed(2) + '万'
                      }
                      return `${params.name} ${params.value}`
                    }
                  },
                  textStyle: {
                    color: color ? "black" : "#fff",
                    fontSize: isExportFont ? isExportFont : 12,
                  },
                },
                emphasis: {
                  //动态展示的样式
                  color: "#fff",
                },
              },
              select: { // 设置选中样式
                itemStyle: {
                  areaColor: null, // 鼠标点击选中区域颜色
                },
              },

              itemStyle: { // 设置地图边界线颜色
                normal: {
                  areaColor: '#031525',
                  borderColor: 'rgba(0, 0, 0, 0.5)',
                },
                emphasis: {
                  areaColor: null, // 鼠标悬停选择区域颜色
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  shadowBlur: 20,
                  borderWidth: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                  label: {
                    show: true,
                  },
                  itemStyle: {
                    areaColor: 'white', // 自定义hover区域颜色
                  },
                },
              },
              // // 文本位置修正
              // textFixed: {
              //   Alaska: [20, -20],
              // },
              // emphasis: { // 对应的鼠标悬浮效果地图模块文字
              //   show: true,
              //   textStyle: {
              //     color: 'red',
              //   },
              // },

              data: JSON.parse(arrList),
            },
          ],
        };
        // 渲染图表
        this.pieEcharts.setOption(this.pieOption);

        window.addEventListener('resize', () => {
          this.pieEcharts.resize();
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
